export default __webpack_public_path__ + "static/media/dyer.3348cc52.png";